<template>
	<div class="AI_tableList" v-loading="loading">
		<div class="AI_tableList-table" v-if="tableData.length">
        <big-table
          :data="tableData"
          :pager='false'
          :key="tableKey"
          :cellStyle="cellStyleBack"
          @cellMouseEnter="cellMouseEnter"
          @cellMouseLeave="cellMouseLeave"
          :headCellStyle="headCellStyle"
          :fieldList="tableHead"
          :tableHeight='350'
          ref='importTable' 
        >
              <template v-for="i in tableHead" v-slot:[i.props]="scope">
                <div v-if="i.props==='fastSelect'" :key="i.props">
                  <el-popover
                     visible-arrow
                     class='popover-fastShow'
                     ref='fastShow'
                     placement="bottom"
                     :isRest='isRests'
                     trigger="click"
                   >
                     <div class="pop-filter">
                       	<select-item
                       		:list = 'fastShowList'
                           :isRest='isRests'
                       		@updateIsRest='updateIsRest'
                       		@clickItem='clickItem'
                       		></select-item>
                     </div>
                     <span  @click="showFastChoose = !showFastChoose" slot="reference">
                         {{ scope.item.label }}
                         <i class="el-icon-caret-bottom" />
                       </span>
                   </el-popover>
                </div>
                <div v-else :key="i.props" class="AI_table_header_c">
                   <span
                      class="AI_table_header_c-label"
                      :class="{'AI_table_header_c-error':scope.item.state===0}">
                      {{ scope.item.label }}
                    </span>
                   <el-select
                      v-model="scope.item.selectValue"
                      placeholder="请选择"
                      size="mini"
                      popper-class="AI_table_header_c-select"
                       @change="handleChangeHead($event,scope.item)"
                      style="width: 120px;"
                    >
                       <el-option
                         v-for="item in headSelectList"
                         :key="item.type"
                         :label="item.name"
                         :value="item.type">
                       </el-option>
                       <!-- 删除列 -->
                       <div class="AI_table_header_c-deleteCol" @click="deleteCol(scope.item)">
                         删除当前列
                       </div>
                    </el-select>
                </div>
              </template>
              <template v-for="i in tableHead" v-slot:[`col-${i.props}`]="scope">
                <div v-if="i.props==='fastSelect'" :key="i.props">
                   <el-checkbox v-model="scope.row.isSelect" @change="handleSelectChange($event,scope.row)"></el-checkbox>
                </div>
                <div v-else :key="i.props" class='textEllipsis tableWrapper'>
                  <span>{{scope.row[i.props].value}}</span>
                  <div class="tableWrapper-abs">
                    <span v-show="scope.row.btnObj[i.props]" @click="handleEditCell(scope.row,i)">编辑</span>
                    <i class="el-icon-warning" v-if="scope.row[i.props].type===1" :title="scope.row[i.props].error"></i>
                  </div>
                </div>
              </template>
          </big-table>
          <div class='selectTip'>
            	当前已选中 {{nowSelect.length}}/{{tableData.length}}
          </div>
          <div class='AI_tableList-model' v-show="!loading&&!isDistinguish">
            <acc-btn
              :text="btnText"
              :type="btnType"
              :disabled="btnType==='2'"
               @click="handleDistinguish"
            ></acc-btn>
          </div>
		</div>
		<div class="AI_tableList-nodata" v-else>
			<img src="/static/img/waitUpload.png" alt="">
			<p>等待上传</p>
		</div>

    <!-- 修改弹框 -->
    <edit-dialog ref="editDialogs" @getEditValue="getEditValue"></edit-dialog>
    <!-- 辅助核算赋值 -->
    <choice-switch ref="choiceSwitchs" @saveChoice="saveChoice"></choice-switch>
	</div>
</template>
<script>
  import bigTable from "@/components/bigTable/index.vue"
  import selectItem from "./selectItem.vue"
  import editDialog from "./editDialog.vue"
  import choiceSwitch from "./choiceSwitch.vue"
	export default {
    components:{
      bigTable,
      selectItem,
      editDialog,
      choiceSwitch
    },
    props:{
      checkedError:{
        type:Boolean,
        default:false
      }
    },
		data() {
			return {
        event:null, // 当前表头选项
        item:null, // 当前表头
        isDistinguish:false,  // 是否发生智能识别
        tableKey:0,  // 表格标识
        btnType:"2",  // 按钮类型
        btnText:"请先匹配表头",  // 按钮文字
        headSelectList:[],　　//　头部下拉框
        isRests:false,
        tableData:[],
        tableData_copy:[],
        tableHead:[],
        nowSelect:[],
        loading:false,
        showFastChoose:false,  // 快选筛选是否展示
        fastShowList:[{
          name:"全选",
          id:1
        },{
          name:"仅正常数据",
          id:2
        },{
          name:"仅异常数据",
          id:3
        }],
        nowEditRow:{},
        nowEditCol:{},
			}
		},
    watch:{
      checkedError(val) {
        this.tableData = [];
        let data = this.$lodash.cloneDeep(this.tableData_copy)
        this.$nextTick(()=>{
          this.tableData = val?data.filter(i=>{return i.isAbnormal}):data;
          this.nowSelect = this.$lodash.cloneDeep(this.tableData);
        })
      }
    },
		created() {
      this.getHeadSelect();
		},
		methods:{
      // 单选
      handleSelectChange(val,row) {
        if(this.nowSelect.length) {
          let iaHave = false,indexs=0;
          this.nowSelect.forEach((i,index)=>{
            if(i.id===row.id) {
              iaHave = true;
              indexs = index;
            }
          })
          if(iaHave) {
            this.nowSelect.splice(indexs,1)
          }else {
            this.nowSelect.push(row);
          }
        }else {
          this.nowSelect.push(row);
        }
      },
      // 删除列
      deleteCol(item) {
        this.$confirm('确定删除当前列?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          this.$http.post('import/deleteColumn',{headId:item.id})
            .then(
                res=>{
                  this.loading = false;
                  if(res&&res.data.code=="1") {
                    this.$message.success("删除成功！")
                    this.getTable();
                  }
                }
            )
        })
      },
      // 获取编辑值
      getEditValue(value) {
        let params = {
          headId: this.nowEditCol.id,
          importId: this.nowEditRow.id,
          value:value
        }
        this.$http.post('import/updateSubjectData',params)
          .then(
              res=>{
                this.$refs.editDialogs.loading = false;
                if(res&&res.data.code=="1") {
                  this.$message.success("修改成功！")
                  //this.nowEditRow[this.nowEditCol.props].value = value;
                  this.getTable();
                  this.$refs.editDialogs.dialogVisible = false;
                }
              }
          )
      },
      // 点击编辑
      handleEditCell(row,column) {
        this.nowEditRow = row;
        this.nowEditCol = column;
        let value = row[column.props].value;
        this.$refs.editDialogs.dialogVisible = true;
        this.$refs.editDialogs.editValue = value;
      },
      // 鼠标移入单元格
      cellMouseEnter(row, column, cell, event) {
        row.btnObj[column.property] = true;
      },
      // 鼠标移出单元格
      cellMouseLeave(row, column, cell, event ) {
        row.btnObj[column.property] = false;
      },
      clickItem(data) {
        this.$refs.fastShow[0].doClose();
        switch (data.id) {
        	case 1:
        		if(data.isSelect) {
        			this.allTableDataSelect(1);
        		}else {
        			this.allTableDataSelect(2);
        		}
        		break;
        	case 2:
        		if(data.isSelect) {
        			this.allTableDataSelect(3);
        		}else {
        			this.allTableDataSelect(4);
        		}
        		break;
        	case 3:
        		if(data.isSelect) {
        			this.allTableDataSelect(5);
        		}else {
        			this.allTableDataSelect(6);
        		}
        		break;
        	default:
        		break;
        }
      },
      // 删除选择
      deleteAll() {
          let idArr =  this.nowSelect.map(i=> { return i.id } )
          if(!idArr.length) return this.$message.warning("系统未检测到您的选择项！")
          this.$confirm('确定删除所有选择项?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loading = true;
            this.$http.post('import/deleteRow',{importId:idArr.toString()})
              .then(
                  res=>{
                    this.loading = false;
                    if(res&&res.data.code=="1") {
                      this.$message.success("删除成功！");
                      this.getTable();
                    }
                  }
              )
          })
      },
      // 表格全部选中 type  1全选2取消全选3选中正常4取消正常5选中异常6取消异常
      allTableDataSelect(type) {
      	let arr = JSON.parse(JSON.stringify(this.tableData)),selectArr=[];
      	this.nowSelect = [];
        console.log(type)
      	arr.forEach((i,index)=>{
      		i.isSelect = false;
      		if(type==1) {
      			i.isSelect = true;
      			selectArr.push(i)
      		}else if(type==2){
      			i.isSelect = false;
      			selectArr = [];
      		}else if(type==3&&!i.isAbnormal) {
      			i.isSelect = true;
      			selectArr.push(i)
      		}else if(type==4){
      			i.isSelect = false;
      			selectArr = [];
      		}else if(type==5&&i.isAbnormal) {
      			i.isSelect = true;
      			selectArr.push(i)
      		}else if(type==6){
      			i.isSelect = false;
      			selectArr = [];
      		}
      	})
      	this.nowSelect = selectArr;
      	this.tableData = arr;
      },
      updateIsRest(data) {
      	this.isRests = data;
      },
      // 获取是否智能识别
      getIsDistinguish() {
        this.$http.post('import/canImport',{})
          .then(
              res=>{
                if(res&&res.data.code=="1") {
                  this.isDistinguish = res.data.data;
                  this.isHeadOk(); // 判断表头是否全部匹配成功
                }
              }
          )
      },
      // 点击智能识别
      handleDistinguish() {
        if(this.btnType ==="2") return;
        this.loading = true;
        this.$emit("getLog",{type:"5",data:null});
        this.$http.post('import/intelligenceSubjectData',{})
          .then(
              res=>{
                if(res&&res.data.code=="1") {
                  this.getTable(true);
                }
              }
          )
      },
      // 表头改变
      handleChangeHead(event,item) {
        this.event = event; // 缓存
        this.item = item;
        if(event===9) {  // 如果是辅助核算类别需要弹出框选则
          this.$refs.choiceSwitchs.dialogVisible = true;
          this.$refs.choiceSwitchs.getTableData(item.id);
          item.selectValue = item.selectOldValue;
          return
        }else {
          this.saveTableHeader(event,item);
        }
      },
      // 保存辅助核算转化
      saveChoice(tableList) {
        let event = this.event,item=this.item;
        this.saveTableHeader(event,item,tableList);
      },
      // 保存表头选择
      saveTableHeader(event,item,tableList) {
        let params = {
          type:event,
          id:item.id,
          list:tableList&&tableList.length?tableList:[]
        }
         this.loading = true;
        this.$http.post('import/adjustmentHead',params)
          .then(
              res=>{
                if(res&&res.data.code=="1") {
                  this.$message.success("保存成功！")
                  this.$refs.choiceSwitchs.dialogVisible = false;
                  item.selectOldValue = item.selectValue;
                  this.getTable();
                }
              }
          )
      },
      // 获取表头下拉框
      getHeadSelect() {
          this.headSelectList=[];
          this.$http.post('import/getHeads',{})
            .then(
                res=>{
                  if(res&&res.data.code=="1") {
                    this.headSelectList =　res.data.data;
                  }
                }
            )
      },
      // 判断表头是否修改完成
      isHeadOk() {
        if(this.isDistinguish) {  // 如果已经智能识别了  就返回
          this.btnType = "1";
          this.$emit("getLog",{type:"4",data:null});
          return;
        };
        let ok = this.tableHead.every(i=>{return i.state===1 });
        if(ok) {
          this.btnType="1";
          this.btnText="智能匹配";
          this.$emit("getLog",{type:"2",data:null});
        }else {
          this.btnType="2";
          this.btnText="请先匹配表头";
          this.$emit("getLog",{type:"0",data:null});
        }
      },
      // 表头单元格样式
      headCellStyle({row, column, rowIndex, columnIndex}) {
        let obj={};
        if(columnIndex!==0&&this.tableHead[columnIndex].state===0) {
          obj = {
            background:'rgba(255, 48, 73, .1)'
          }
        }
        return obj;
      },
      // 单元格样式
      cellStyleBack({row, column, rowIndex, columnIndex}) {
        let obj={};
        if(row[column.property]&&row[column.property].type===1) {
          obj = {
            background:'rgba(255, 48, 73, .1)'
          }
        }
        return obj;
      },
      // 获取表格及表头
			getTable(noRender) {
        this.loading = true;
        this.tableHead=[];
        this.tableData=[];
        this.nowSelect = [];
				this.$http.post('import/getDataAndHead',{})
          .then(res=>{
              if(!noRender) this.loading = false;
              if(res&&res.data.code=="1") {
                let data = res.data.data;
                if(!data.head.length&&!data.data.length) {
                  this.$emit("getLog",{type:"1",data:null});
                  return;
                }
                let head = [{
                  header: true,
                  label: '快选',
                  props: 'fastSelect',
                  width: '70',
                  type:'slot',
                  state:1,
                  overflow:true,
                  normal:null
                 }];
                // 封装头部信息
                data.head.forEach(i=>{
                  head.push({
                    header: true,
                    label: i.tableName,
                    oldLabel: i.tableOldName,
                    props: i.value,
                    minWidth: '200',
                    selectValue:i.type===999?"":i.type,
                    selectOldValue:i.type===999?"":i.type,
                    id:i.id,
                    overflow:true,
                    normal:i.normal,
                    state:i.state,
                    type:'slot' ,
                  })
                })
                if(noRender) {  // 如果为true则不用渲染执行动画
                  let rqData = {
                    tableHead:head,
                    tableData:data.data
                  }
                  this.$emit("getLog",{type:"3",data:rqData});
                  return;
                }
                // 重置选项
                this.tableKey += 1;
                this.tableHead = head;
                 this.resetCheck(data.data);
                this.getIsDistinguish(); // 判断是否智能识别
                 this.$emit("getIsHaveError",!data.red);
              }
          })
			},
      resetCheck(tableData) {
        let data = this.$lodash.cloneDeep(tableData);
        if(data.length) {
          data.forEach(i=>{
            i.isAbnormal = false;  // 是否异常列
            i.btnObj = {};
            for(var k in i) {
              i.btnObj[k] = false;  // 按钮重置
              if(i[k].type === 1) {
                i.isAbnormal = true;
              }
            }

            i.isSelect = true;
          })
        }
        this.tableData_copy = this.$lodash.cloneDeep(data);
        this.tableData = this.checkedError?data.filter(i=>{return i.isAbnormal}):data;
        this.nowSelect = this.$lodash.cloneDeep(this.tableData);
        // 如果没有异常且当前显示为  显示异常   则自动取消
        if(this.checkedError&&!this.tableData.length) {
          this.$emit("noError",true)
        }
      },
		}
	}
</script>
<style lang="less">
  .AI_table_header_c-select {
    .el-select-dropdown__list {
      padding-bottom: 30px;
    }
    .AI_table_header_c-deleteCol {
      position: absolute;
      width: 100%;
      padding: 5px 0;
      bottom: 0px;
      border-top: 1px solid #eee;
      color: #F56C6C;
      font-weight: 600;
      cursor: pointer;
      background-color: #fff;
      z-index: 9999;
      text-align: center;
    }
  }

	.AI_tableList {
    min-height: 389px;
    position: relative;
    .selectTip {
    	font-weight: 600;
    	padding: 10px 0;
    }
    &-model {
      position: absolute;
      bottom: 49px;
      left: 0;
      width: 100%;
      height: 296px;
      line-height: 296px;
      text-align: center;
      z-index: 9999;
      background:rgba(0,0,0,.3);
    }
    .AI_table_header_c {
      display: flex;
      align-items: center;
      padding: 0 10px !important;
      &-label {
        margin-right: 5px;
      }
      &-error {
        color: #FF3049;
      }
    }
		&-table {
      .el-table th div {
        line-height: 23px;
        padding: 0;
      }
      .tableWrapper {
        padding-right: 50px;
        &-abs {
          position: absolute;
          right: 10px;
          top: 50%;
          z-index: 8;
          transform: translateY(-50%);
          i {
            color: #FF3049;
            cursor: pointer;
          }
          span {
            cursor: pointer;
            color: #409EFF;
          }
        }
      }
		}
		&-nodata {
			text-align: center;
      padding-top: 150px;
			img {
				width: 80px;
				height: 80px;
			}
			p {
				color: #ACB7C3;
				margin-top: 10px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/AIImport/list.vue